var _path, _path2, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7219 28.5815V28.2652C13.7683 27.3294 14.0682 26.4226 14.5908 25.6384C15.4605 24.6964 16.0559 23.5421 16.3145 22.2965C16.3145 21.3338 16.3145 20.3574 16.3986 19.3947C16.833 14.76 21.4157 11.5557 25.9422 11.5557H26.0543C30.5809 11.5557 35.1635 14.76 35.612 19.3947C35.6961 20.3574 35.612 21.3338 35.6821 22.2965C35.9441 23.545 36.5389 24.7029 37.4058 25.6522C37.9322 26.4294 38.2327 27.3328 38.2747 28.2652V28.5678C38.306 29.8251 37.8729 31.0511 37.0554 32.0197C35.9752 33.1522 34.5093 33.8568 32.9353 34.0001C28.3197 34.4952 23.6629 34.4952 19.0473 34.0001C17.475 33.8507 16.0112 33.1471 14.9271 32.0197C14.1223 31.0503 13.6951 29.8316 13.7219 28.5815Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4668 38.7861C23.188 39.6913 24.247 40.2772 25.4096 40.4139C26.5721 40.5507 27.7422 40.2272 28.661 39.515C28.9436 39.3044 29.1979 39.0595 29.4178 38.7861",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6665,
    cy: 15.8891,
    r: 5.77778,
    fill: "#FF4D5E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.8a68fe5c58ac4b2286f81d281a46299d.svg";
export { ForwardRef as ReactComponent };